import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { BuscarUsuarioResponse, CambiarContrasenaParams, UsuarioProps, UsuarioResponse } from '../../interfaces/admin/UsuarioInterface';
import { JuezProps } from '../../interfaces/catalogos/JuezInterface';
import { SecretarioProps } from '../../interfaces/catalogos/SecretarioInterface';
import { HttpResponse } from '../../interfaces/auth/AuthInterface';

export const Usuarios = () => {

    return new Promise<UsuarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/', token)
            .then( ({ data } : { data :UsuarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarUsuario = ( params:UsuarioProps ) => {

    return new Promise<UsuarioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Actualizar', params, token)
            .then( ({ data } : { data :UsuarioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idUsuario: 0,                 
                    nombre: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,     
                    idTipoUsuario: 0,
                });
            });
        }

    });

}

export const AgregarUsuario = ( params:UsuarioProps ) => {

    return new Promise<UsuarioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Agregar', params, token)
            .then( ({ data } : { data :UsuarioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idUsuario: 0,                 
                    nombre: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,    
                    idTipoUsuario: 0,    
                });
            });
        }

    });

}

export const BuscarUsuarioRH = ( curp: string ) => {

    return new Promise<BuscarUsuarioResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Usuario/BuscarUsuario/${ curp }`, token)
            .then( ({ data } : { data : BuscarUsuarioResponse} ) => {
                resolve( data );
            })
            .catch( (error: AxiosError) => {
                
                const data: BuscarUsuarioResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}

export const ObtenerJueces = () => {

    return new Promise<JuezProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/ObtenerJueces', token)
            .then( ({ data } : { data :JuezProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerSecretarios = () => {

    return new Promise<SecretarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/ObtenerSecretarios', token)
            .then( ({ data } : { data : SecretarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const CambiarContrasena = ( params: CambiarContrasenaParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/CambiarContrasena/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( (error: AxiosError) => {
                
                const data: HttpResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}